enum ActionTypes {
  FETCHING = `userApiRequest/FETCHING`,
  SUCCESS = `userApiRequest/SUCCESS`,
  ERROR = `userApiRequest/ERROR`,
  IDLE = `userApiRequest/IDLE`,
}

export { ActionTypes };
